import { NgModule } from '@angular/core';
import { FeatureFlagDirective } from '../directives/feature-flag.directive';

@NgModule({
  declarations: [FeatureFlagDirective],
  exports: [FeatureFlagDirective],
})
export class FeatureFlagModule {}
